export const VIEW_TYPES = {
    SIZE_GUIDE: 'Size Guide',
    REVIEWS: 'Reviews',
    SHIPPING_RETURNS: 'Shipping & Returns',
    CRASH_REPLACEMENT: 'Crash Replacement',
};
